var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeftSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/chevron-left-small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/chevron-left-small",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0908627,3.376577 C14.5929654,2.87447433 15.4070346,2.87447433 15.9091373,3.376577 C16.41124,3.87867966 16.41124,4.69274891 15.9091373,5.19485158 L9.105,12 L15.9091373,18.8051484 C16.3726167,19.2686278 16.4082689,19.9979249 16.0160941,20.5022993 L15.9091373,20.623423 C15.4070346,21.1255257 14.5929654,21.1255257 14.0908627,20.623423 L6.376577,12.9091373 C5.87447433,12.4070346 5.87447433,11.5929654 6.376577,11.0908627 L14.0908627,3.376577 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftSmall);
export default __webpack_public_path__ + "static/media/chevron-left-small.51097a5338b1a24b59b8d252b97d500d.svg";
export { ForwardRef as ReactComponent };